import {at} from 'lodash'
import React from 'react'
import update, { extend } from 'immutability-helper'
import {buildContext} from './utils'

extend('$auto', function(value, object) {
  return object ?
    update(object, value):
    update({}, value)
})

extend('$autoArray', function(value, object) {
  return object ?
    update(object, value):
    update([], value)
})

export default function createContext(initialState, { onInit, onUpdate}) {
  const Context = React.createContext()
  const {Provider, Consumer} = Context

  class ContextProvider extends React.Component {

    constructor (props) {
      super(props)
      const setState = this.setState.bind(this)
      this.state = {
        ...initialState,
        setState,
        updateState: updateState.bind(this),
        at: (...paths) => at(this.state, paths)
      }
      function updateState (first, ...params) {
        const commands = Array.isArray(first) ? first.concat(params) : [first].concat(params)
        return new Promise((resolve, reject) => {
          try {
            const state = commands.reduce((state, command) => update(state, command), this.state)
            setState(state, () => resolve(state))
          } catch (e) {
            reject(e)
          }
        })
      }

    }

    componentDidMount() {
      if (onInit) {
        const context = () => buildContext(this.props, this.state)
        onInit(context(), context)
      }
    }

    componentDidUpdate(props, state) {
      if (onUpdate)
        onUpdate(buildContext(this.props, this.state), buildContext(props, state))
    }

    render() {
      const context = buildContext(this.props, this.state)
      return (
        <Provider value={context}>
          {this.props.children}
        </Provider>
      )
    }
  }

  return {Consumer, ContextProvider, Context}

}

export function createLoadableList (override) {
  return {loaded: false, items: [], refreshes:0, ...(override || {})}
}

export function createLoadableObject (override) {
  return {loaded: false, items: {}, refreshes:0, ...(override || {})}
}

export function updateLoadableList(path, items) {
  const initial = {loaded: {$set: items != undefined}, items: {$set: items || []}}
  return path.split('.').reverse().reduce((command, name) => ({[name]: command}), initial)
}

export function updateLoadableObject(path, items) {
  const initial = {loaded: {$set: items != undefined}, items: {$set: items || {}}}
  return path.split('.').reverse().reduce((command, name) => ({[name]: command}), initial)
}


